import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function useLoremIpsum() {
    const { i18n } = useTranslation();

    const { ProductType, Localisation } = useSelector(state => state.builder.variables);
    const t = i18n.getFixedT(Localisation);

    let LI = {
        button: {
            link: "/",
            text: t("LIButtonText"),
        },

        getInTouch: {
            text: t("LIGetInTouchText"),
            email: t("LIGetInTouchEmail"),
            button: t("LIGetInTouchButton"),
        },

        Header: t("LIHeaderText"),

        Logotype: t("LILogotype"),

        Features: new Array(3).fill({
            header: t("LIFeaturesHeader"),
            text: t("LIFeaturesText"),
        }),

        Steps: [
            {
                header: t("LIStepsStep1Header"),
                text: t("LIStepsStep1Text"),
            },
            {
                header: t("LIStepsStep2Header"),
                text: t("LIStepsStep2Text"),
            },
            {
                header: t("LIStepsStep3Header"),
                text: t("LIStepsStep3Text"),
            },
        ],

        Numbers: [
            {
                unit: "percent",
                text: t("LINumbersText"),
                number: t("LINumbersNumber"),
            },
        ],

        Feedbacks: [
            {
                name: t("LIFeedbacksName"),
                feedback: t("LIFeedbacksFeedback"),
                company: t("LIFeedbacksCompany"),
            },
        ],

        Offers: [
            {
                button: t("LIOffersButton"),
                goToOurStore: t("LIOffersGoToOurStore"),
                cost: t("LIOffersCost"),
                currency: t("LIOffersCurrency"),
                description: t("LIOffersDescription"),
                features: t("LIOffersFeatures"),
                title: t("LIOffersTitle"),
            },
        ],

        Events: [
            {
                Location: t("LIEventsLocation"),
                dateStart: Date.now() + 604800000,
                dateEnd: "",
                timeStart: "11:00",
                timeEnd: "",
            },
        ],

        MenuLinks: [
            { id: "Home", text: t("LIMenuLinksHome") },
            { id: "Features", text: t("LIMenuLinksFeatures") },
            { id: "Offers", text: t("LIMenuLinksOffers") },
            { id: "Feedbacks", text: t("LIMenuLinksFeedbacks") },
        ],
    };

    ({});

    switch (ProductType) {
        case "mobile-app":
            LI = {
                ...LI,

                Header: t("LIbPTMobileAppHeader"),
                Logotype: t("LIbPTMobileAppLogotype"),

                button: {
                    link: "/",
                    text: t("LIbPTMobileAppButtonText"),
                },

                Features: new Array(4).fill(null).map((_, i) => ({
                    header: t(`LIbPTMobileAppFeaturesFeature${i + 1}Header`),
                    text: t(`LIbPTMobileAppFeaturesFeature${i + 1}Text`),
                })),

                Steps: new Array(3).fill(null).map((_, i) => ({
                    header: t(`LIbPTMobileAppStepsStep${i + 1}Header`),
                    text: t(`LIbPTMobileAppStepsStep${i + 1}Text`),
                })),

                Numbers: [
                    {
                        unit: "number",
                        text: t("LIbPTMobileAppNumbersNumber1Text"),
                        number: t("LIbPTMobileAppNumbersNumber1Number"),
                    },
                ],

                Feedbacks: [
                    {
                        name: t("LIbPTMobileAppFeedbacksFeedback1Name"),
                        feedback: t("LIbPTMobileAppFeedbacksFeedback1Feedback"),
                        company: t("LIbPTMobileAppFeedbacksFeedback1Company"),
                    },
                ],

                Offers: new Array(4).fill(null).map((_, i) => ({
                    title: t(`LIbPTMobileAppOffersOffer${i + 1}Title`),
                    cost: t(`LIbPTMobileAppOffersOffer${i + 1}Cost`),
                    currency: t(`LIbPTMobileAppOffersOffer${i + 1}Currency`),
                    description: t(`LIbPTMobileAppOffersOffer${i + 1}Description`),
                    features: t(`LIbPTMobileAppOffersOffer${i + 1}Features`),
                    button: t(`LIbPTMobileAppOffersOffer${i + 1}Button`),
                    goToOurStore: t(`LIbPTMobileAppOffersOffer${i + 1}GoToOurStore`),
                })),

                getInTouch: {
                    text: t("LIbPTMobileAppGetInTouchText"),
                    email: t("LIbPTMobileAppGetInTouchEmail"),
                    button: t("LIbPTMobileAppGetInTouchButton"),
                },
            };

            break;

        case "web-product":
            LI = {
                ...LI,

                Header: t("LIbPTWebProductHeader"),
                Logotype: t("LIbPTWebProductLogotype"),

                button: {
                    link: "/",
                    text: t("LIbPTWebProductButtonText"),
                },

                Features: new Array(4).fill(null).map((_, i) => ({
                    header: t(`LIbPTWebProductFeaturesFeature${i + 1}Header`),
                    text: t(`LIbPTWebProductFeaturesFeature${i + 1}Text`),
                })),

                Steps: new Array(3).fill(null).map((_, i) => ({
                    header: t(`LIbPTWebProductStepsStep${i + 1}Header`),
                    text: t(`LIbPTWebProductStepsStep${i + 1}Text`),
                })),

                Numbers: [
                    {
                        unit: "number",
                        text: t("LIbPTWebProductNumbersNumber1Text"),
                        number: t("LIbPTWebProductNumbersNumber1Number"),
                    },
                ],

                Feedbacks: [
                    {
                        name: t("LIbPTWebProductFeedbacksFeedback1Name"),
                        feedback: t("LIbPTWebProductFeedbacksFeedback1Feedback"),
                        company: t("LIbPTWebProductFeedbacksFeedback1Company"),
                    },
                ],

                Offers: new Array(4).fill(null).map((_, i) => ({
                    title: t(`LIbPTWebProductOffersOffer${i + 1}Title`),
                    cost: t(`LIbPTWebProductOffersOffer${i + 1}Cost`),
                    currency: t(`LIbPTWebProductOffersOffer${i + 1}Currency`),
                    description: t(`LIbPTWebProductOffersOffer${i + 1}Description`),
                    features: t(`LIbPTWebProductOffersOffer${i + 1}Features`),
                    button: t(`LIbPTWebProductOffersOffer${i + 1}Button`),
                    goToOurStore: t(`LIbPTWebProductOffersOffer${i + 1}GoToOurStore`),
                })),

                getInTouch: {
                    text: t("LIbPTWebProductGetInTouchText"),
                    email: t("LIbPTWebProductGetInTouchEmail"),
                    button: t("LIbPTWebProductGetInTouchButton"),
                },
            };

            break;

        case "cross-platform":
            LI = {
                ...LI,

                Header: t("LIbPTCrossPlatformHeader"),
                Logotype: t("LIbPTCrossPlatformLogotype"),

                button: {
                    link: "/",
                    text: t("LIbPTCrossPlatformButtonText"),
                },

                Features: new Array(4).fill(null).map((_, i) => ({
                    header: t(`LIbPTCrossPlatformFeaturesFeature${i + 1}Header`),
                    text: t(`LIbPTCrossPlatformFeaturesFeature${i + 1}Text`),
                })),

                Steps: new Array(3).fill(null).map((_, i) => ({
                    header: t(`LIbPTCrossPlatformStepsStep${i + 1}Header`),
                    text: t(`LIbPTCrossPlatformStepsStep${i + 1}Text`),
                })),

                Numbers: [
                    {
                        unit: "number",
                        text: t("LIbPTCrossPlatformNumbersNumber1Text"),
                        number: t("LIbPTCrossPlatformNumbersNumber1Number"),
                    },
                ],

                Feedbacks: [
                    {
                        name: t("LIbPTCrossPlatformFeedbacksFeedback1Name"),
                        feedback: t("LIbPTCrossPlatformFeedbacksFeedback1Feedback"),
                        company: t("LIbPTCrossPlatformFeedbacksFeedback1Company"),
                    },
                ],

                Offers: new Array(4).fill(null).map((_, i) => ({
                    title: t(`LIbPTCrossPlatformOffersOffer${i + 1}Title`),
                    cost: t(`LIbPTCrossPlatformOffersOffer${i + 1}Cost`),
                    currency: t(`LIbPTCrossPlatformOffersOffer${i + 1}Currency`),
                    description: t(`LIbPTCrossPlatformOffersOffer${i + 1}Description`),
                    features: t(`LIbPTCrossPlatformOffersOffer${i + 1}Features`),
                    button: t(`LIbPTCrossPlatformOffersOffer${i + 1}Button`),
                    goToOurStore: t(`LIbPTCrossPlatformOffersOffer${i + 1}GoToOurStore`),
                })),

                getInTouch: {
                    text: t("LIbPTCrossPlatformGetInTouchText"),
                    email: t("LIbPTCrossPlatformGetInTouchEmail"),
                    button: t("LIbPTCrossPlatformGetInTouchButton"),
                },
            };

            break;
    }

    return LI;
}
